import Operations from './components/Operations/Operations';
import { PriceGuideContainer } from './components/PriceGuideContainer/PriceGuideContainer';

export const PriceGuideOperations = () => (
  <PriceGuideContainer>
    <Operations />
  </PriceGuideContainer>
);
